// // import React, { useState, useEffect } from 'react';
// // import { Container, TextField, Button, Typography, Box } from '@mui/material';
// // import { useDispatch } from 'react-redux';
// // import { useNavigate, Link, useLocation } from 'react-router-dom';
// // import { loginSuccess } from '../store';
// // import { getDocs, collection, query, where } from 'firebase/firestore';
// // import { db } from '../firebase';
// // import iconB from '../assets/bot_4712139.png';


// // const LoginK = () => {
// //   const [username, setUsername] = useState('');
// //   const [password, setPassword] = useState('');
// //   const dispatch = useDispatch();
// //   const location = useLocation();
// //   const navigate = useNavigate();

// //   const [animate, setAnimate] = useState(false);

// //   const handleButtonClick = () => {
// //     setAnimate(true);
// //     setTimeout(() => setAnimate(false), 300);
// //   };

// //   const changeBodyBackground = (background) => {
// //     document.body.style.background = background;
// //   };


// //   useEffect(() => {
// //     changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
// //     return () => changeBodyBackground(''); // Reset background on unmount
// //   }, []);


// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     try {
// //       const q = query(collection(db, 'users'), where('username', '==', username));
// //       const querySnapshot = await getDocs(q);

// //       if (querySnapshot.empty) {
// //         throw new Error('User not found');
// //       }

// //       const userDoc = querySnapshot.docs[0];
// //       const userData = userDoc.data();

// //       if (userData.password !== password) {
// //         throw new Error('Invalid password');
// //       }

// //       dispatch(loginSuccess(userData));

// //       // ניתוב בהתאם לתפקיד המשתמש
// //       if (userData.role === 'warehouseManager') {
// //         navigate('/warehouse-manager'); // ניתוב לדף הבית

// //       } else if (userData.role === 'admin') {
// //         navigate('/ManageItemsK'); // ניתוב לדף הבית

// //       } else if (userData.role === 'orderManager') {
// //         navigate('/order-manager'); // ניתוב לדף הבית

// //       } else if (userData.role === 'user') {
// //         navigate('/homeK'); // ניתוב לדף הבית

// //       }
// //     } catch (error) {
// //       console.error('Failed to log in:', error.message);
// //       alert('Login failed: ' + error.message);
// //     }
// //   };

// //   return (
// //     // <form onSubmit={handleSubmit}>
// //     <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
// //       <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
// //         <Button
// //           component={Link}
// //           to={location.pathname === '/chat_s' ? '/chat_s' : '/chat_s'}
// //           onClick={handleButtonClick}
// //           sx={{
// //             display: 'flex',
// //             flexDirection: 'column', // Change to column to stack items
// //             alignItems: 'center',
// //             textDecoration: 'none',
// //             borderRadius: '30px',
// //             backgroundColor: 'transparent',
// //             flexGrow: 1,
// //             justifyContent: 'center', // Center items vertically
// //             width: '20%', // Half of the parent width
// //           }}
// //         >
// //           <img
// //             src={iconB}
// //             alt="Icon 2"
// //             style={{
// //               width: '45px',
// //               height: '45px',
// //               border: 'solid 2px black',
// //               borderRadius: '30px',
// //               marginBottom: '8px', // Add some space between the image and text
// //             }}
// //           />
// //           חזרה
// //         </Button>
// //       </Box>

// //       <Typography component="h1" variant="h5">Log in</Typography>

// //       <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>

// //         <h2>Login</h2>
// //         <div>
// //           <label>Username:</label>
// //           <TextField
// //             type="text"
// //             value={username}
// //             onChange={(e) => setUsername(e.target.value)}
// //           />
// //         </div>
// //         <div>
// //           <label>Password:</label>
// //           <TextField
// //             type="password"
// //             value={password}
// //             onChange={(e) => setPassword(e.target.value)}
// //           />
// //         </div>
// //         <button type="submit">Login</button>
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default LoginK;




// import React, { useState, useEffect } from 'react';
// import { Container, TextField, Button, Typography, Box } from '@mui/material';
// import { useDispatch } from 'react-redux';
// import { useNavigate, Link, useLocation } from 'react-router-dom';
// import { loginSuccess } from '../store';
// import { getDocs, collection, query, where, addDoc } from 'firebase/firestore';
// import { db } from '../firebase';
// import iconB from '../assets/bot_4712139.png';

// const LoginK = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [commandRank, setCommandRank] = useState('');
//   const [individual, setIndividual] = useState('');
//   const [isCreatingUser, setIsCreatingUser] = useState(false); // Toggle for user creation mode
//   const [animate, setAnimate] = useState(false);

//   const dispatch = useDispatch();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const handleButtonClick = () => {
//     setAnimate(true);
//     setTimeout(() => setAnimate(false), 300);
//   };

//   const changeBodyBackground = (background) => {
//     document.body.style.background = background;
//   };

//   useEffect(() => {
//     changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
//     return () => changeBodyBackground(''); // Reset background on unmount
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (isCreatingUser) {
//       if (!username || !password || !confirmPassword || !commandRank || !individual) {
//         alert("Please fill in all fields.");
//         return;
//       }
//       if (password !== confirmPassword) {
//         alert("Passwords do not match.");
//         return;
//       }
//       try {
//         await addDoc(collection(db, 'users'), {
//           username,
//           password,
//           role: 'user',
//           commandRank,
//           individual,
//           status: 'unconfirmed' // New users are unconfirmed by default
//         });
//         alert("User created successfully. Awaiting admin confirmation.");
//         setIsCreatingUser(false);
//         setUsername('');
//         setPassword('');
//         setConfirmPassword('');
//         setCommandRank('');
//         setIndividual('');
//       } catch (error) {
//         console.error("Failed to create user:", error.message);
//       }
//     } else {
//       try {
//         const q = query(collection(db, 'users'), where('username', '==', username));
//         const querySnapshot = await getDocs(q);
//         if (querySnapshot.empty) throw new Error('User not found');

//         const userDoc = querySnapshot.docs[0];
//         const userData = userDoc.data();

//         if (userData.password !== password) throw new Error('Invalid password');
//         if (userData.status !== 'approved') {
//           throw new Error('Your account is not yet approved for login.');
//         }
//         dispatch(loginSuccess(userData));

//         if (userData.role === 'warehouseManager') navigate('/warehouse-manager');
//         else if (userData.role === 'admin') navigate('/ManageItemsK');
//         else if (userData.role === 'orderManager') navigate('/order-manager');
//         else if (userData.role === 'user') navigate('/homeK');
//       } catch (error) {
//         console.error('Failed to log in:', error.message);
//         alert('Login failed: ' + error.message);
//       }
//     }
//   };

//   return (
//     <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//       <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
//         <Button
//           component={Link}
//           to={location.pathname === '/chat_s' ? '/chat_s' : '/chat_s'}
//           onClick={handleButtonClick}
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             textDecoration: 'none',
//             borderRadius: '30px',
//             backgroundColor: 'transparent',
//             flexGrow: 1,
//             justifyContent: 'center',
//             width: '20%',
//           }}
//         >
//           <img
//             src={iconB}
//             alt="Icon 2"
//             style={{
//               width: '45px',
//               height: '45px',
//               border: 'solid 2px black',
//               borderRadius: '30px',
//               marginBottom: '8px',
//             }}
//           />
//           חזרה
//         </Button>
//       </Box>

//       <Typography component="h1" variant="h5">
//         {isCreatingUser ? 'Create New User' : 'Log in'}
//       </Typography>

//       <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
//         {isCreatingUser && (
//           <Typography variant="h6">Create New User</Typography>
//         )}

//         <TextField
//           label="Username"
//           type="text"
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//           fullWidth
//           required
//           margin="normal"
//         />

//         <TextField
//           label="Password"
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           fullWidth
//           required
//           margin="normal"
//         />

//         {isCreatingUser && (
//           <>
//             <TextField
//               label="Confirm Password"
//               type="password"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//               fullWidth
//               required
//               margin="normal"
//             />
//             <TextField
//               label="Command Rank"
//               type="text"
//               value={commandRank}
//               onChange={(e) => setCommandRank(e.target.value)}
//               fullWidth
//               required
//               margin="normal"
//             />
//             <TextField
//               label="Individual"
//               type="text"
//               value={individual}
//               onChange={(e) => setIndividual(e.target.value)}
//               fullWidth
//               required
//               margin="normal"
//             />
//           </>
//         )}

//         <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
//           {isCreatingUser ? 'Save User' : 'Login'}
//         </Button>

//         <Button
//           onClick={() => setIsCreatingUser(!isCreatingUser)}
//           variant="text"
//           color="secondary"
//           fullWidth
//           sx={{ mt: 1 }}
//         >
//           {isCreatingUser ? 'Back to Login' : 'Create New User'}
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default LoginK;


import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { loginSuccess } from '../store';
import { getDocs, collection, query, where, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import iconB from '../assets/bot_4712139.png';

const LoginK = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [commandRank, setCommandRank] = useState('');
  const [individual, setIndividual] = useState('');
  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const [animate, setAnimate] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    setAnimate(true);
    setTimeout(() => setAnimate(false), 300);
  };

  const changeBodyBackground = (background) => {
    document.body.style.background = background;
  };

  useEffect(() => {
    changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
    return () => changeBodyBackground(''); // Reset background on unmount
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreatingUser) {
      if (!username || !password || !confirmPassword || !commandRank || !individual) {
        alert("נא למלא את כל השדות.");
        return;
      }
      if (password !== confirmPassword) {
        alert("הסיסמאות אינן תואמות.");
        return;
      }
      try {
        await addDoc(collection(db, 'users'), {
          username,
          password,
          role: 'user',
          commandRank,
          individual,
          status: 'לא מאושר'
        });
        alert("משתמש נוצר בהצלחה. ממתין לאישור מנהל.");
        setIsCreatingUser(false);
        setUsername('');
        setPassword('');
        setConfirmPassword('');
        setCommandRank('');
        setIndividual('');
      } catch (error) {
        console.error("יצירת משתמש נכשלה:", error.message);
      }
    } else {
      try {
        const q = query(collection(db, 'users'), where('username', '==', username));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) throw new Error('המשתמש לא נמצא');

        const userDoc = querySnapshot.docs[0];
        const userData = userDoc.data();

        if (userData.password !== password) throw new Error('סיסמה שגויה');
        if (userData.status !== 'מאושר') {
          throw new Error('החשבון שלך עדיין לא אושר להתחברות.');
        }
        dispatch(loginSuccess(userData));

        if (userData.role === 'warehouseManager') navigate('/warehouse-manager');
        else if (userData.role === 'admin') navigate('/ManageItemsK');
        else if (userData.role === 'orderManager') navigate('/order-manager');
        else if (userData.role === 'user') navigate('/homeK');
      } catch (error) {
        console.error('התחברות נכשלה:', error.message);
        alert('התחברות נכשלה: ' + error.message);
      }
    }
  };

  return (
    <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Button
          component={Link}
          to={location.pathname === '/chat_s' ? '/chat_s' : '/chat_s'}
          onClick={handleButtonClick}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textDecoration: 'none',
            borderRadius: '30px',
            backgroundColor: 'transparent',
            flexGrow: 1,
            justifyContent: 'center',
            width: '20%',
          }}
        >
          <img
            src={iconB}
            alt="Icon 2"
            style={{
              width: '45px',
              height: '45px',
              border: 'solid 2px black',
              borderRadius: '30px',
              marginBottom: '8px',
            }}
          />
          חזרה
        </Button>
      </Box>

      <Typography component="h1" variant="h5">
        {isCreatingUser ? 'יצירת משתמש חדש' : 'התחברות'}
      </Typography>

      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        {isCreatingUser && (
          <Typography variant="h6">פרטי משתמש חדש</Typography>
        )}

        <TextField
          label="שם משתמש"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          required
          margin="normal"
        />

        <TextField
          label="סיסמה"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          required
          margin="normal"
        />

        {isCreatingUser && (
          <>
            <TextField
              label="אימות סיסמה"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
              required
              margin="normal"
            />
            <TextField
              label="דרגת פיקוד"
              type="text"
              value={commandRank}
              onChange={(e) => setCommandRank(e.target.value)}
              fullWidth
              required
              margin="normal"
            />
            <TextField
              label="מזהה אישי"
              type="text"
              value={individual}
              onChange={(e) => setIndividual(e.target.value)}
              fullWidth
              required
              margin="normal"
            />
          </>
        )}

        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
          {isCreatingUser ? 'שמור משתמש' : 'התחבר'}
        </Button>

        <Button
          onClick={() => setIsCreatingUser(!isCreatingUser)}
          variant="text"
          color="secondary"
          fullWidth
          sx={{ mt: 1 }}
        >
          {isCreatingUser ? 'חזרה להתחברות' : 'יצירת משתמש חדש'}
        </Button>
      </Box>
    </Box>
  );
};

export default LoginK;
